import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { GetAlertsComponent, validateConstantValues, getConstantTextFields} from "./utils"
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from "@material-ui/core/Tooltip"
import HelpIcon from "@material-ui/icons/Help"
import NumberFormat from 'react-number-format';
import i18next from "i18next"

let this_box_type = "number"

export function NumberRoundBox(props) {
    const { t } = useTranslation()
    let { node, read_only, handleConfigurationOpen, handleNodeRemove } = props

    return (
        <div>
            <div style={{display:"flex", alignItems: "center"}}>
                <div
                    style={{ display: "flex", width: "100%", cursor: "pointer", margin: "0px" }}
                    onClick={() => handleConfigurationOpen(node)}
                >
                    <div style={{ display: "flex", flexDirection: "column", margin: "auto 0px" }}>
                        <div className={["normalText", "normalSmallSize"].join(" ")}>
                            {node.node.properties.ndigits_value ? t("round_to") + " " + node.node.properties.ndigits_value + " " + t("decimal_places") : ""}
                        </div>
                    </div>
                    {!read_only && (node.node.alerts || []).length > 0 ?
                        <GetAlertsComponent alerts={node.node.alerts} /> : null}
                </div>
                {!read_only && <><IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(node)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(node)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton></>}
            </div>
        </div>
    )
}

export function NumberRoundConfiguration(props) {
    const { t } = useTranslation()
    let { node, read_only, handleNodeChange, handleConfigurationClose } = props

    let standardTextField = getConstantTextFields(this_box_type)

    const [nodeState, setNodeState] = useState(node)

    useEffect(() => {
        setNodeState(node)
    }, [node])

    const handleNodeStateChange = (obj_key, value) => {
        let new_node = { ...nodeState }
        new_node.node.properties[obj_key] = value
        setNodeState(new_node)
    }

    const handleSave = () => {
        handleConfigurationClose()
        handleNodeChange(nodeState)
    }

    return (
        <div style={{ flexGrow: "1", padding: "20px", display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex" }}>
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>{t(node.node.description)}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help, index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                    <HelpIcon style={{ fontSize: "14px", display: "flex", margin: "auto 5px" }} />
                </Tooltip>
            </div>
            <div className="internalCardContainer" style={{display:"flex", flexDirection: "row", justifyContent: 'center'}}>
                <NumberFormat
                    style={{textAlign:"center", width:"80%", margin:"3px auto"}}
                    error={!validateConstantValues(this_box_type,nodeState.node.properties.ndigits_value)}
                    {...standardTextField.props}
                    value={nodeState.node.properties.ndigits_value}
                    onValueChange={(e) => handleNodeStateChange("ndigits_value", e.floatValue)}
                    suffix={t("decimal_places")}
                    InputProps={{
                        readOnly: read_only
                      }}
                />   
            </div>
            <div style={{ display: "flex", margin: "auto auto 5px auto" }}>
                <div
                    className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                    style={{ width: "120px" }}
                    onClick={handleConfigurationClose}
                >
                    {read_only ? "X" : t("discard")}
                </div>
                {!read_only &&
                    <div
                        className={
                            validateConstantValues(this_box_type,nodeState.node.properties.ndigits_value)
                                ?
                                ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                :
                                ["button", "standard", "normalText", "normalMediumSize", "disabled"].join(" ")}
                        style={{ width: "120px" }}
                        onClick={validateConstantValues(this_box_type,nodeState.node.properties.ndigits_value) ? handleSave : null}
                    >
                        {t("save")}
                    </div>}
            </div>
        </div>
    )
}

export class NumberRoundBoxClass {
    constructor(rulesContext) {
        this.rulesContext = rulesContext
    }

    validate(node) {
        let put_error = false
        let alerts = []
        const {t} = i18next

        if ((node.node.children || []).length !== 1) {
            put_error = true
            alerts.push("box_validation_must_have_one_children")
        }
        //Validate if first children of the node is Number
        else{
            let first_children = node.node.children[0]
            if (first_children?.instance?.getType(first_children) !== "number"){
                put_error = true
                    alerts.push(t("O primeiro filho deste nó deve ser do tipo ") + t("number")+ t(". Atualmente ele é do tipo ") + t(first_children?.instance?.getType(first_children)))
            } 
        }
        //Validate if parent is valid
        if (node.parentNode != null) {
            if (node.parentNode.on_error) {
                put_error = true
                alerts.push("box_validation_invalid_parent_node")
            }
        }
        return { validated: !put_error, alerts: alerts }
    }

    getType(node) {
        return this_box_type
    }
}